import React from 'react'

export default () => (
  <div>
    <p>React Static is a progressive static site generator for React.</p>
  </div>
)
